import { isCustomerDataIncomplete, selectBasket, updateCompany, updateCustomerData } from 'containers/OrderDetails/basketSlice'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { cartCustomer } from 'rest/urls'
import { POST } from 'rest/request'

/**
 * Przejście z wyboru danych do faktury do podsumowania.
 * Przed przejściem sprawdzamy w koszyku (POST /cart/customer, sam cartId [+ companyId]),
 * czy dane klienta / firmy wystarczają do umowy — jeśli nie, od razu kierujemy na /contract,
 * zamiast pokazywać ładujące się podsumowanie, które i tak by tam przekierowało.
 * Zabezpieczenie w OrderSummary zostaje (np. reaktywacja koszyka z linku).
 */
const useProceedToSummary = (waitForSync) => {
  const { cartId, tenant } = useSelector(selectBasket)
  const [isChecking, setChecking] = useState(false)
  const checkingRef = useRef(false)
  const mountedRef = useRef(true)

  const dispatch = useDispatch()
  const { push } = useHistory()

  useEffect(() => () => {
    mountedRef.current = false
  }, [])

  const proceed = useCallback(async (company = false) => {
    if (checkingRef.current) return
    dispatch(updateCompany(company || false))

    let path = '/order/summary'
    if (cartId) {
      checkingRef.current = true
      setChecking(true)
      try {
        // koszyk musi znać klienta, zanim zapytamy /cart/customer
        if (waitForSync) await waitForSync()

        const body = { cartId }
        const companyId = tenant?.company?.id || company?.id
        if (companyId) body.companyId = companyId

        const response = await POST(cartCustomer, { body })
        dispatch(updateCustomerData(response))
        if (isCustomerDataIncomplete(response?.customerValidation)) path = '/contract'

      } catch (err) {
        // nie blokujemy użytkownika — walidację i tak powtórzy podsumowanie
        console.warn('Customer validation: failed')

      } finally {
        checkingRef.current = false
        if (mountedRef.current) setChecking(false)
      }
    }

    if (mountedRef.current) push(path)
  }, [cartId, dispatch, push, tenant?.company?.id, waitForSync])

  return { proceed, isChecking }
}

export default useProceedToSummary
